import { ValidationObserver } from "vee-validate/dist/vee-validate.full";
import BInput from "@/components/singles/BInput/component.vue";

export default {
  name: "password-management",
  components: {
    ValidationObserver,
    BInput
  },
  props: ["uid", "name"],
  data() {
    return {
      form: {
        inputs: [
          {
            icon: "fa-key",
            label: null,
            name: "password",
            placeholder: "Password",
            type: "password",
            validation: "required|min:8|confirmed:confirmation",
            value: "",
            focus: true
          }
        ]
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {
    async Validate() {
      this.$validator.validateAll().then(result => {
        this.form.showErrors = !result;

        if (result && !this.$store.state.saving) {
          this.Save();
        }
      });
    },

    async Save() {
      this.$store.state.saving = true;
      this.$helpers
        .PostApi("set/userPassword", {
          userUID: this.uid,
          password: this.form.inputs[0].value
        })
        .then(res => {
          if (res[0].changed === 1) {
            this.$helpers.ShowStatus("New password has been set.", 0);
            this.$helpers.ClearForm(this.form);

            this.$store.state.saved = true;
            this.$store.state.saving = false;
            this.$emit("success");
          } else {
            this.$helpers.ShowStatus("No password was changed", 0, "warning");
            this.$emit("error");
          }
        })
        .catch(err => {
          this.$helpers.ShowStatus(
            "Error: could not set new password",
            0,
            "warning"
          );

          this.$store.state.saved = false;
          this.$store.state.saving = false;
          this.$emit("error");
        });
    }
  }
};
